/**
 * Span attribute and span names the TypeScript services emit, as registered in
 * docs/tracing-registry.json (docs/TRACING.md). One string per concept across
 * every service; registry.spec.ts keeps this file and the registry equal.
 */
export const SERVICE_NAME_DASHBOARD = 'blacksmith-dashboard'
export const SERVICE_NAME_CODESMITH = 'codesmith'

export const ATTR_SANDBOX_ID = 'sandbox.id'
export const ATTR_INSTALLATION_ID = 'installation.id'
export const ATTR_SESSION_ID = 'session.id'
export const ATTR_SESSION_TURN = 'session.turn'
export const ATTR_INTERACTION_IN_FLIGHT_AT_END = 'interaction.in_flight_at_end'
export const ATTR_INTERACTION_DROPPED_SPANS = 'interaction.dropped_spans'

export const SPAN_SANDBOX_CREATE = 'sandbox.create'
export const SPAN_SANDBOX_EXEC = 'sandbox.exec'
